import ShortenedTitle from "components/General-UI/ShortenedTitle";
import Spinner from "components/General-UI/Spinner";
import AppIcon from "components/Home/ui/AppIcon/AppIcon";
import { PrivateLockBlue } from "graphics/icons/BranchBar/PrivateLock";
import { nameThisId, suggestionForAppId } from "helpers/efficeHelpers";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactSwitch from "react-switch";
import { selectData } from "slices/efficeCacheSlice";
import { createNewEffice } from "slices/efficeTreeSlice";
import { setInputBoxActive } from "slices/generalSlice";

const NewAppForm = ({
  priv,
  setPriv,
  appModalNode,
  appModalAppId,
  onDismiss,
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [content, setContent] = useState("");
  const [error, setError] = useState(null);
  const ancestorNodeName = useSelector(
    (state) => selectData(state)[appModalNode.permissions_id]?.content
  );
  const ref = useRef();

  const onEnter = () => {
    let trimmedContent = content.trim();
    if (trimmedContent.length !== 0 && content.length < 200) {
      setLoading(true);
      dispatch(
        createNewEffice(
          appModalNode.id,
          priv,
          trimmedContent,
          true,
          appModalAppId
        )
      )
        .then(() => {
          setError(null);
          onDismiss();
          setLoading(false);
        })
        .catch((message) => {
          setError(message);
          setLoading(false);
        });
    } else if (trimmedContent)
      setError("Name too long, must be less than 200 characters");
    else setError("You must enter an effice name");
  };

  useEffect(() => {
    if (ref.current) {
      ref.current.focus();
    }
    return () => {
      setPriv(false);
    };
  }, [setPriv]);

  useEffect(() => {
    return () => dispatch(setInputBoxActive(false));
  }, [dispatch]);

  return (
    <div className="new-app-form">
      <div className="mt-4">
        <label className="input-name-label" htmlFor="new-branch-name">
          Name:
        </label>
        <label className="private-container">
          <span>private</span>
          <ReactSwitch
            height={25}
            handleDiameter={21}
            onChange={() => setPriv(!priv)}
            checked={priv}
          />
        </label>
      </div>
      <div className="name-input-container">
        {priv && <PrivateLockBlue />}
        <div className="app-icon">
          <AppIcon appId={appModalAppId} />
        </div>
        <input
          className={`input-box `}
          id="new-branch-name"
          autoComplete="off"
          ref={ref}
          value={content}
          disabled={loading}
          maxLength="150"
          placeholder={suggestionForAppId(appModalAppId)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              onEnter();
              e.preventDefault();
            }
          }}
          onChange={(e) => setContent(e.target.value)}
          onFocus={() => dispatch(setInputBoxActive(true))}
          onBlur={() => dispatch(setInputBoxActive(false))}
        />
      </div>
      <div className="private-info mb-4 mt-3">
        <div className={`${!priv ? "public" : ""}`}>
          {priv ? (
            <>
              {`Only selected members who have access to `}
              <span className="font-bold private-dark-color">
                <ShortenedTitle //LOL - getting the ancestor permissions id - neeed to get the parent's permissions_id of the closest private effice
                  title={ancestorNodeName}
                  maxChars={50}
                />
              </span>
              {` will have access to this ${nameThisId(
                appModalAppId
              )}. Enter a name to proceed to selection.`}
            </>
          ) : null}
        </div>
      </div>
      <button
        className={`confirm-button growth-button`}
        style={{ height: "45px" }}
        disabled={!content || loading}
        onClick={onEnter}
      >
        {loading ? <Spinner /> : "OK"}
      </button>
      <div className="server-response-error">{error}</div>
    </div>
  );
};

export default NewAppForm;
